// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"55689356","513":"9e828275","703":"42fbdb88"}[chunkId] + ".chunk.js";
};